(function () {
    "use strict";

    var moduleObj = moduler('individualsAndFamiliesMenu', {
        defaults: {
            categories: '.fCats a',
            subcategories: '.fOptions > div[data-category]',
            activeClass: 'active'
        },

        init: function (module) {
            // shim for IE11 to add forEach on NodeList as well.
            (function () {
                if (typeof NodeList.prototype.forEach === "function") return false;
                NodeList.prototype.forEach = Array.prototype.forEach;
            })();

            [].forEach.call(document.querySelectorAll(module.settings.categories), el => {
                el.addEventListener('click', function (e) {
                    e.preventDefault();
                    moduleObj.hideAll(module, this);
                    moduleObj.show(module, this);
                }, false);
            });

            document.querySelector('.fCats select').addEventListener('change', function (e) {
                e.preventDefault();
                moduleObj.hideAll(module, this);
                moduleObj.show(module, this);
            }, false);
        },

        hideAll: function (module, el) {
            let active = document.querySelector(`.fCats li.${module.settings.activeClass}`);
            if (active) active.classList.remove(module.settings.activeClass);
            let subcategories = document.querySelectorAll(module.settings.subcategories);
            subcategories.forEach(el => {
                el.classList.remove(module.settings.activeClass);
            });
        },

        show: function (module, el) {
            let category = (el.nodeName.toLowerCase() === 'a') ? el.dataset.category : el.value;
            document.querySelector('.fOptions').classList.add(module.settings.activeClass); // used to hide the default view.
            el.parentNode.classList.add(module.settings.activeClass);
            document.querySelector('.fOptions div[data-category="' + category + '"]').classList.add(module.settings.activeClass);
        }
    });
})();